import React from 'react';

import { createNavigationLayoutClassName } from './navigationLayoutStyles';

type Props = {
  logoNode: React.ReactNode;
  primaryNode: React.ReactNode;
  secondaryNode: React.ReactNode;
};

export const NavigationLayout = (props: Props) => {
  const { logoNode, primaryNode, secondaryNode } = props;

  return (
    <div className={createNavigationLayoutClassName('wrapper')}>
      <div className={createNavigationLayoutClassName('logoSlot')}>
        {logoNode}
      </div>
      <div className={createNavigationLayoutClassName('primarySlot')}>
        {primaryNode}
      </div>
      <div className={createNavigationLayoutClassName('secondarySlot')}>
        {secondaryNode}
      </div>
    </div>
  );
};
